module.exports = __webpack_public_path__ + "img/betflix-support.8fd60443.png";